/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */

/**
 * This module defines event handlers for semantiv events related to shelves and saved searches
 */
define('dng-reservations',['jquery', 'dng-common'], function($, dng) {
	$(document).ready(function(){

		/**
		 * Show a feedback message when a reservation is performed.
		 */
		$('body').on('reservation-performed reservation-item-performed reservation-extra-performed reservation-shard-performed', function(event, response){
			//alert(response.response_str);

            $('#reserveItemModal').modal('hide');

			if (response.response_code == 1){
				dng.feedbackMessage(response.response_str, 'success');
			} else {
				dng.feedbackMessage(response.response_str, 'danger');
			}
		});

		$('body').on('reservation-performed', function(event, response) {

			$(event.target).trigger('reservations-updated');
		});

		/**
		 * Request a reservation
		 * Trigger a reservation-performed event
		 */
		$('body').on('reservation-requested', function(event, manId, libId, issueId, resNote){ 
                    var actionUrl = "mydiscovery/reserve/" + manId + "/" + libId;
                    var tail = [issueId, resNote];

                    actionUrl += '/' + JSON.stringify(tail);

                    $.post(actionUrl).done(function(response){
                            $(event.target).trigger('reservation-performed', [response, manId, libId, issueId, resNote]);
                    });
		});
                
		$('body').on('reservation-item-requested', function(event, manId, libId, issueId, resNote){ 
                    var actionUrl = "mydiscovery/reserveItem/" + manId + "/" + libId;
//                    var tail = [issueId, resNote];
                    var tail = [resNote];

                    actionUrl += '/' + JSON.stringify(tail);

                    $.post(actionUrl).done(function(response){
                            $(event.target).trigger('reservation-item-performed', [response, manId, libId]);
                    });
		});

		/**
		 * Request an extra reservation
		 * Trigger a reservation-extra-performed
		 */
		$('body').on('reservation-extra-requested', function(event, manId, libId, issueId, resNote, element){
                    var actionUrl = "mydiscovery/reserveExtra/" + manId + "/" + libId;
                    var tail = [issueId, resNote];

                    actionUrl += '/' + JSON.stringify(tail);

                    $.post(actionUrl).done(function(response){
                            $(event.target).trigger('reservation-extra-performed', [response, manId, libId, issueId, resNote]);
                    });
		});

		/**
		 * Request a shard reservation
		 * Trigger a reservation-shard-performed
		 */
		$('body').on('reservation-shard-requested', function(event, manId, libId, issueId, resNote, element){
                    var actionUrl = "mydiscovery/reserveShard/" + manId + "/" + libId;
                    var tail = [issueId, resNote];

                    actionUrl += '/' + JSON.stringify(tail);

                    $.post(actionUrl).done(function(response){
                            $(event.target).trigger('reservation-shard-performed', [response, manId, libId, issueId, resNote]);
                    });
		});

		/**
		 * Request an MLOL record
		 * Trigger a popup with the response
		 * NOTE: the manId is only the last part of the trineId taken from template with $external_id
		 */
		$('body').on('reserve-mlol-requested', function(event, manId){
			var actionUrl = "mydiscovery/reserveMLOL/" + manId;
			var newWin = window.open("", "_blank", "width=1025,height=600,top=100,left=100,scrollbars=yes");
			$.post(actionUrl).done(function(response){
				if (response.response_code == 1){
					//	The response give use the url, parameter and value
					//	to perform a new post request inside a popup
					var form = '<form id="mlol_form" name="mlol_form" method="post" action="'+response.url[0]+'"><input name="'+response.param_name[0]+'" type="hidden" value="'+response.param_value[0]+'"></form>';
					$(newWin.document).ready(function(){
						$(newWin.document).contents().append(form);
						$(newWin.document).contents().find('#mlol_form').trigger('submit');
					});
				} else {
					newWin.window.close();
					dng.feedbackMessage(response.response_str, 'danger');
				}
				$(event.target).trigger('reserve-mlol-loaded');
			});
		});
            
                /**
                 * Se il radiobutton non è selezionato, prenota in base alle altre edizioni
                 * altrimenti fa come da default cioè senza edizioni.
                 */
                $('body').on('click', '#smartReserve', function() {
                    document.getElementById("bestManId").value = $('#bestNewManId').val();
                    $("#buttonConfirm").trigger("click"); 
                });

                /**
                 * Al cambio della biblioteca di ritiro.
                 */
                $('body').on('change', 'select[name=libraryId]', function() {
                    if ((checkMonography()) && checkSmartreserve()) {
                        $('#spinner').attr('data-isloading', 1);
                        document.getElementById("coverReal").src = '';
                        document.getElementById('coverCheck').src = '';
                        $("#coverFake").hide();
                        $("#coverReal").hide();
                        $("#manAnteprima").hide();
                        changeManifestation(function(response) {
                            document.getElementById('coverCheck').src = response.urlImage;
                            document.getElementById("bestNewManId").value = response.idBest;
                            document.getElementById("bmID").innerHTML = response.urlEdizione;
                            document.getElementById("bmType").innerHTML = '<b>Tipologia</b>: '+response.bibType;
                            document.getElementById("bmAuthor").innerHTML = '<b>Autori</b>: '+response.autori;
                            document.getElementById("bmTitle").innerHTML = '<b>Titolo</b>: '+response.titolo;
                            document.getElementById("bmEdition").innerHTML = response.edizione;
                            document.getElementById("bmPubblic").innerHTML = response.pubblicazione;
                            document.getElementById("bmDesc").innerHTML = response.descrizione;
                            document.getElementById('bmTrunkCoverInfosTitle').innerHTML = response.truncatedCoverInfosTitle;
                            document.getElementById('bmTrunkCoverInfosAuthor').innerHTML = response.truncatedCoverInfosAuthor;
                            document.getElementById('bmCopie').innerHTML = response.gestioneCopie;
                            checkBestManifestation();
                        });
                        $('#spinner[data-isloading]').removeAttr('data-isloading');
                    } else { $('#manAnteprima').remove(); }
                });
                
                function checkMonography() {
                    if ($("#isMonographyReserve").val() == 1) return true;
                    return false;
                }

                function checkSmartreserve() {
                    if ($("#smartReserveFlag").val() == 1) return true;
                    return false;
                }            
            
                /**
                 * Ricalcolo della manifestation che si trova a disposizione.
                 * Solo se è abilitata la prenotazione per edizione (manId !== 0).
                 * @returns {undefined}
                 */
                function changeManifestation(successCallback) {
                    var libId = $("#library-id option:selected").val();
                    var manId = $("#OldManId").val();
                    $.ajax({
                        url: 'mydiscovery/ajaxBestManifestation/',
                        data: { libId: libId,
                                manId: manId,
                                output: true },
                        dataType: 'json',
                        success: successCallback,
                        complete: function() { checkCover(); }
                    });
                };
 
                var checkCover = function() {
                    var img = new Image();
                    img.src = $('#coverCheck')[0]['src'];
                    img.onload = function() {
                        if (((this.width <= 1) && (this.height <= 1)) || (!this.width) || (!this.height)) {
                            $("#coverReal").hide();
                            $("#coverFake").show();
                        } else {
                            document.getElementById("coverReal").src = document.getElementById('coverCheck').src;
                            $("#coverFake").hide();
                            $("#coverReal").show();
                        }
                    }
                }

                /**
                 * Verifica se è stata calcolata qualche manifestation migliore.
                 * Se si abilita la visualizzazione dell'anteprima e della cover
                 * @returns {undefined}
                 */
                var checkBestManifestation = function() {
                    //checkCover();                    
                    if ((checkSmartreserve()) && ($("#bestNewManId").val() != 0) && ($("#bestNewManId").val() != "") && ($("#bestNewManId").val() != $("#OldManId").val())) {
                        checkCover();
                        $("#manAnteprima").show();
                    } else {
                        $("#manAnteprima").hide();
                    }
                };
                
                /**
		 * Request a dialog for a reservation
		 * Trigger a reserve-dialog-loaded event
		 */
		$('body').on('reserve-dialog-requested', function(event, manid, element){
                    $.get('data/html/reserve-dialog/' + manid).done(function(response){
                        $.parseHTMLNode(response).modal('show');
                        $('#reserveModal').on('hidden.bs.modal', function (e) {
                            $('.reserve-dialog').remove();
                        });
                        $(event.target).trigger('reserve-dialog-loaded');
                        checkBestManifestation();
                    });
		});

		$('body').on('reserve-item-dialog-requested', function(event, manid, element){
                    $.get('data/html/reserve-item-dialog/' + manid).done(function(response){
                        $.parseHTMLNode(response).modal('show');
                        $('#reserveItemModal').on('hidden.bs.modal', function (e) {
                            $('.reserve-item-dialog').remove();
                        });
                        $(event.target).trigger('reserve-item-dialog-loaded');
                        $('#manAnteprima').remove();
                    });
		});

		/**
		 * Request a dialog for a reservation
		 * Trigger a reserve-dialog-loaded event
		 */
		$('body').on('reserve-issue-dialog-requested', function(event, manid, issueid){
                    $.get('data/html/reserve-dialog/' + manid + '/' + issueid).done(function(response){
                        $.parseHTMLNode(response).modal('show');
                        $('#reserveModal').on('hidden.bs.modal', function (e) {
                            $('.reserve-dialog').remove();
                        });
                        $(event.target).trigger('reserve-dialog-loaded');
                        $('#manAnteprima').remove();                        
                    });
		});

		/**
		 * Request a dialog for a shard reservation
		 * Trigger a reserve-shard-dialog-loaded event
		 */
		$('body').on('reserve-shard-dialog-requested', function(event, manid, element){
			$.get('data/html/reserve-shard-dialog/' + manid).done(function(response){
				$.parseHTMLNode(response).modal('show');
				$(event.target).trigger('reserve-shard-dialog-loaded');
			});
		});

		$('body').on('reservation-shard-requested', '.confirm-modal', function(){
			$(this).find('.btn').button('loading');
		});

		/**
		 * Request a dialog for an extra reservation
		 * Trigger a reserve-extra-dialog-loaded event
		 */
		$('body').on('reserve-extra-dialog-requested', function(event, manid, element){
			$.get('data/html/reserve-extra-dialog/' + manid).done(function(response){
				$.parseHTMLNode(response).modal('show');
				$(event.target).trigger('reserve-extra-dialog-loaded');
			});
		});

		$('body').on('reservation-extra-requested', '.confirm-modal', function(){
			$(this).find('.btn').button('loading');
		});

		$('body').on('reservation-remove-requested', function(event, requestId, form){
			$.post('mydiscovery/deleteReservation/' + requestId).done(function(){
				$(event.target).trigger('reservations-updated', [{id: requestId}]);
			});
		});

		$('body').on('reservation-changedevlib-requested', function(event, requestId, form){
			$.post('mydiscovery/changeReservationLib', form.serialize()).done(function(){
				$(event.target).trigger('reservations-updated', [{id: requestId}]);
			});
		});
	});
});

